import type { TrailerWithAxlesResponse } from '@contracts/trailer/TrailerWithAxlesResponse';
import type { Client } from '@src/clients/domain/Client';
import { Drawer } from '@src/common/components/Drawer';
import { PageLayout } from '@src/common/components/Page';
import { useToast } from '@src/common/hooks/useToast';
import { useCreateTrailer } from '@src/trailer/hooks/useCreateTrailer';
import { TrailerPageForm } from '@src/trailer/TrailerPageForm';
import { useTranslation } from 'react-i18next';

interface Props {
  client: Client;
  isOpen: boolean;
  onClose: () => void;
  onAdd: (newTrailer: TrailerWithAxlesResponse) => void;
}

export const AddTrailerDrawer = ({ isOpen, client, onAdd, onClose }: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();

  const { createTrailer, isLoading } = useCreateTrailer({
    clientId: client.id,
    onSuccess: (newTrailer) => {
      showSuccessToast(t('addTrailerSuccess'));
      onAdd(newTrailer);
    },
    onError: () => {
      showErrorToast(t('addTrailerError'));
    },
  });

  return (
    <Drawer open={isOpen} onClose={onClose} width="90vw">
      <PageLayout title={t('trailerInformation')}>
        <TrailerPageForm
          onSubmit={createTrailer}
          onCancel={onClose}
          isLoading={isLoading}
          client={client}
        />
      </PageLayout>
    </Drawer>
  );
};
